export var getFormattedAmenityItems = function getFormattedAmenityItems(items, amenitiesConjunctionText) {
  return items.map(function (item, index) {
    if (index === items.length - 2) {
      return "".concat(item, " ").concat(amenitiesConjunctionText, " ");
    }

    if (index === items.length - 1) {
      return item;
    }

    return "".concat(item, ", ");
  });
};